export enum ChemotherapyStatus {
  PENDING = 'P',
  STARTED = 'I',
  ADMINISTERED = 'C',
  SUSPENDED = 'S',
  CHECKED_FIRST = 'Q',
}

export enum ChemotherapyMedicationType {
  MEDICATION = 'N',
  PRE_MEDICATION = 'S',
  POST_MEDICATION = 'P',
  RESIDENTIAL_USE = 'D'
}

export interface ScheduleMedicationDoseInfo {
  admRouteDescription?: string;
  doseQuantity?: number;
  doseUnitMeasureCode?: string;
  doseUnitMeasureDescription?: string;
}

export interface FirstMedicationCheckInfoResponse {
  responseDescription: string;
}

export interface ResponseBodyProps {
  hourDate?: string;
  informDose?: boolean;
  materialCode?: number;
  message?: string;
  messageType?: string;
  read?: boolean;
  remainingDoseQuantity?: number;
  success?: boolean;
  total?: number;
  totalRead?: number;
}

export enum MedicationStatus {
  ADMINISTERED = 'ADMINISTERED',
  CHECKED_FIRST = 'CHECKED_FIRST',
  INTERRUPTED = 'INTERRUPTED',
  PENDING = 'PENDING',
  PENDING_REFUSAL = 'PENDING_REFUSAL',
  PREPARATION = 'PREPARATION',
  REFUSED_ADMINISTERED = 'REFUSED_ADMINISTERED',
  STARTED = 'STARTED',
}

export enum Params {
  NOT_ALLOWED = 'N',
  ALLOWED = 'S',
  DO_NOT_CONTROL = 'NC',
}

export enum Conditionals {
  POSITIVE = 'S',
  NEGATIVE = 'N'
}

export enum AdminScheduleType {
  MEDICATION = 'medication',
  SOLUTION = 'solution'
}

export enum DisplayMessages {
  ADMINISTRED_MESSAGE = 'tws.emar.administered-item',
  MEDICATION_READ_SUCCESS = 'text.medication-read-with-success',
  ERROR_VALIDATE_LOGIN = 'login-message.invalid-user-password-text',
  VALIDATE_BUTTON_EXP = '$expression.$702951',
  FIRST_MED_CHECK_CREATED = 'text.first-checked-fulfilled-with-success',
  ADMINISTRATION = 'text.administration',
  FIRST_CHECK_NOT_POSSIBLE = 'text.it-was-not-possible-to-perform-the-first-check',
  ADM_NOT_ALLOWED = 'text.the-administration-of-item-is-not-allowed',
  REC_NOT_ALLOWED = 'text.the-record-of-item-is-not-allowed',
  EMAR_COULD_NOT_MANAGE = 'tws.emar.could-not-manage-suspended',
  WISH_CONTINUE = 'msg.wish-continue',
  LABEL_NO = 'label.status-no',
  LABEL_YES = 'label.status-yes',
  FINISH = 'text.finish',
  START_CHEMOTHERAPY = 'text.start-chemotherapy',
  EMAR_FIRST_CHECK = 'tws.emar.perform-first-check',
}

export enum TimelineItemType {
  MEDICATION        = 'M',
  GLYCEMIA_CONTROL  = 'G',
  SOLUTION          = 'SOL',
  SUPPLEMENTS       = 'S',
  ENTERAL_NUTRITION = 'SNE'
}

export enum PrescriptionStatus {
  CHECKED_FIRST = 'Q',
  ADMINISTERED = 'A'
}